import { render, staticRenderFns } from "./FormNode.vue?vue&type=template&id=de28fa54&"
import script from "./FormNode.vue?vue&type=script&lang=js&"
export * from "./FormNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports